<section class="features-section section-padding" id="features">
  <div class="container">

    <div class="section-head-dark">
      <h2>Everything <span class="heading-gradient">You Need</span></h2>
      <p>Powerful features designed to make your party experience seamless and unforgettable.</p>
    </div>

    <div class="features-grid">
      @for (feature of features; track feature.title) {
        <div class="feature-card-dark" [class.feature-card-highlight]="feature.highlight">
          <div class="feature-icon-wrap">
            <img [class]="' feature-icon'" [src]="'assets/images/'+feature.icon"/>
          </div>
          <h5 class="feature-title">{{ feature.title }}</h5>
          <p class="feature-desc">{{ feature.description }}</p>
        </div>
      }
    </div>

  </div>
</section>
